import * as TYPES from './types'
import { functions } from '@/services/firebase'

export default {
  [TYPES.LOAD_BADGES] ({ commit }, { locale, callback = function(){} }) {
    const loadBadges = functions.httpsCallable('loadBadges')
    loadBadges({ locale }).then(response => {
      commit(TYPES.SET_BADGES, response.data)
      callback(null, true)
    })
  },
}